import React from 'react';
import ECharts from 'echarts-for-react';

const BarChart = ({ data, config, title }) => {
  const xAxisKey = config?.xAxis || (data?.length > 0 ? Object.keys(data[0])[0] : null);
  const yAxisKey = config?.yAxis || (data?.length > 0 ? Object.keys(data[0])[1] : null);
  const groupByKey = config?.groupBy;

  if (!xAxisKey || !yAxisKey || !data || data.length === 0) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  // Group data if needed
  let chartData = data;
  if (groupByKey && groupByKey !== 'none') {
    const grouped = {};
    data.forEach((item) => {
      const key = item[groupByKey];
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(item);
    });
    chartData = Object.entries(grouped).map(([key, items]) => ({
      [groupByKey]: key,
      [xAxisKey]: items[0][xAxisKey],
      [yAxisKey]: items.reduce((sum, item) => sum + (Number(item[yAxisKey]) || 0), 0),
    }));
  }

  const option = {
    title: {
      text: title || 'Bar Chart',
      textStyle: { color: '#201e1d' },
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#201e1d',
      borderColor: 'transparent',
      borderWidth: 0,
      borderRadius: 8,
      textStyle: { color: '#f5ead8' },
    },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '15%', containLabel: true },
    xAxis: {
      type: 'category',
      data: chartData.map((item) => item[xAxisKey]),
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: '#82796a', fontFamily: 'Space Grotesk', fontSize: 11 },
      axisLine: { lineStyle: { color: '#c0b6a5' } },
      splitLine: { lineStyle: { color: '#eee7db' } },
    },
    series: [
      {
        data: chartData.map((item) => Number(item[yAxisKey]) || 0),
        type: 'bar',
        itemStyle: {
          borderRadius: [6, 6, 0, 0],
          color: new (require('echarts').graphic.LinearGradient)(0, 0, 0, 1, [
            { offset: 0, color: '#c67139' },
            { offset: 1, color: '#8c491a' },
          ]),
        },
      },
    ],
  };

  return (
    <ECharts
      option={option}
      style={{ width: '100%', height: '400px' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default BarChart;
